<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>

<template>
  <div>
    <h2>En 1709 se consagra el nuevo santuario en el Cerro del Tepeyac</h2>
    <img @click="imageClicked(0)" src="galerias/guadalupe/g6/G6.jpg" class="mainphoto"/>
    <p class="photo-description">Traslado de la imagen y primer milagro de la Virgen de Guadalupe. Autor: José Juárez. Óleo sobre tela. 1653. Col. Museo de la Basílica de Guadalupe.</p>
    <p>Tras la aparición de la Virgen de Guadalupe en 1531, se construyó una ermita y un primer santuario, el cual fue sustituido por un más amplio,  construido por los arquitectos José Durán y Pedro de Arrieta de 1695 a 1709. Su consagración se llevó a cabo el 30 de abril de 1709, con una procesión que trasladó la imagen de Nuestra Señora de Guadalupe.</p>
    <p>En la imagen podemos apreciar un testimonio de dicho acto mediante el cuadro “Verdadero mapa del Tepeyac” de  Arellano, 1709.</p>
    <h5>VER MÁS</h5>
    <p>
      <ul>
        <li><a target="_blank" href="http://artecolonialamericano.az.uniandes.edu.co:8080/artworks/593">artecolonialamericano.az.uniandes.edu.co</a></li>
      </ul>
    </p>

    <h4>Primera construcción, la “casita sagrada”.</h4>
    <img @click="imageClicked(1)" class="mainphoto" src="galerias/guadalupe/g6/G6_A.jpg"/>
    <p>El Nican Mopohua cita estas palabras de la Virgen de Guadalupe: “Mucho quiero, mucho deseo que aquí me levanten mi casita sagrada”. El 26 de diciembre de 1531, a catorce días del Acontecimiento Guadalupano, se realizó un traslado del sagrado original de la Virgen de Guadalupe desde la Ciudad de México a una humilde ermita en el Tepeyac.</p>
    <p>En el Mapa de Uppsala (1550), que corresponde a la Ciudad de México y sus alrededores, se aprecia la existencia de una construcción de culto que corresponde a la ermita guadalupana del Tepeyac.</p>
    <p>Si deseas conocer más:
      <ul>
        <li><a target="_blank" href="https://www.wdl.org/es/item/503/">www.wdl.org</a></li>
        <li><a target="_blank" href="https://virgendeguadalupe.org.mx/wp-content/uploads/2019/12/BG-Febrero-2004.pdf">virgendeguadalupe.org.mx</a></li>
      </ul>
    </p>
  </div>
</template>

<script>
export default {
  name: "Sala2m5",
  data() {
    return {};
  },
  methods: {
    imageClicked(idx) {
      this.$emit("onImageClicked", idx);
    }
  },
  components: {},
  props: {},
  mounted() {},
};
</script>
